import styles from './PerformanceMaintenanceSummary.module.scss';
import { ProductHighlights } from './ProductHighlights';

interface PerformanceMaintenanceSummaryProps {
	performanceData?: {
		fabricInfo?: string[];
	};
	cleaningData?: {
		cleaningMaintenanceInfo?: string[];
	};
}

export function PerformanceMaintenanceSummary({
	performanceData,
	cleaningData,
}: PerformanceMaintenanceSummaryProps = {}) {
	// Prepare cleaning data - first item as subheadline, rest as bullet points
	const cleaningSubheadline = cleaningData?.cleaningMaintenanceInfo?.[0];
	const cleaningBulletPoints = cleaningData?.cleaningMaintenanceInfo?.slice(1) || [];

	return (
		<div className={styles.container}>
			<ProductHighlights
				headline="Performance Summary"
				bulletPoints={performanceData?.fabricInfo || []}
			/>

			<ProductHighlights
				headline="Cleaning and Maintenance"
				subheadline={cleaningSubheadline}
				bulletPoints={cleaningBulletPoints}
			/>
		</div>
	);
}